var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5677 1.96815L17.5307 16.8186C17.3015 17.8667 16.704 18.1276 15.8549 17.6338L11.2276 14.0982L8.99475 16.3248C8.74766 16.5811 8.541 16.7953 8.06478 16.7953L8.39724 11.9088L16.9736 3.87337C17.3465 3.52866 16.8927 3.33767 16.394 3.68238L5.79154 10.6045L1.22707 9.12321C0.234204 8.80179 0.216233 8.09374 1.43372 7.59996L19.2873 0.468193C20.1139 0.146774 20.8372 0.659181 20.5677 1.96815Z",
    fill: "#2b451e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTelegramIcon);
export default __webpack_public_path__ + "static/media/social-telegram-icon.5144d754531959b3e0673025d71318d4.svg";
export { ForwardRef as ReactComponent };